module.exports = __webpack_public_path__ + "img/column_202603.322c59ea.png";